module.exports = "//d274d294w9cx2v.cloudfront.net/da7c2e1c573d91f373c6cacb9d5be2e2a5fa5f99/images/venmoBadge.png";